<template>
  <div>
    <Notification
      :content="notificationContent"
      :type="notificationStatus"
      :isNotificationOpen="isNotificationOpen"
      @notificationClosed="closeNotification"
    />
    <InstancesLayout>
      <DatInstances slot="dat-instances" />
    </InstancesLayout>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator';
import Notification from '@/components/common/Notification/Notification.vue';
import { INotification, store } from '@/store/modules/datInstances/types';
import InstancesLayout from './components/InstancesLayout/InstancesLayout.vue';
import DatInstances from './components/DatInstances/DatInstances.vue';

@Component({
  components: {
    InstancesLayout,
    DatInstances,
    Notification
  }
})
export default class Instances extends Vue {
  @store.Getter
  private getNotification: INotification;

  private isNotificationOpen = false;

  private notificationContent = '';

  private notificationStatus = '';

  private closeNotification() {
    this.isNotificationOpen = false;
    this.notificationContent = '';
    this.notificationStatus = '';
  }

  @Watch('getNotification')
  private onNotificationChanged(newv: INotification | null) {
    if (newv) {
      this.isNotificationOpen = true;
      this.notificationStatus = newv.notificationStatus;
      const content = newv.content ? newv.content : '';
      if (newv.code === 200) {
        this.notificationContent = `${this.$t(content)}`;
      } else {
        this.notificationContent = `${this.$tc(content, newv.code, { field: newv.field })}`;
      }
    } else {
      this.closeNotification();
    }
  }
}
</script>
